"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@bluebase/core");
/**
 * A render prop component to control the DrawerLayout
 */
exports.DrawerActions = core_1.getComponent('DrawerActions');
